export default __webpack_public_path__ + "static/havant-1-b611a84e102f07ccf7d6e95a4e2a13fe.jpg";